
import React, { useEffect, useState } from 'react';
import { fetchCertificationDetails, fetchCourseDetails, postapprovaldetails } from '../../service/certificationAPI';
import InitialApprovalPopup from '../certificationPopup/InitialApprovalPopup';
import ReattemptPopup from '../certificationPopup/ReattemptPopup';
import { encryptStorage } from '../../constant';
import DOMPurify from 'dompurify';
import FinalApprovalPopup from '../certificationPopup/FinalApprovalPopup';
// SQ-1.2- 1.19 : Intialize variables
const CertificationList = ({ certificates,
    totalRecords,
    numberOfRecords,
    searchTerm,
    filters,
    handleSortChange,
    setCertificates,
    sortColumn,
    sortOrder,
    fetchCertifications,
    onShowMore,
    showLoadMore
}) => {


    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isOpenAddCertification, setIsOpenAddCertification] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const [isFinalApproval, setIsFinalApproval] = useState(false);
    const [popupType, setPopupType] = useState('final');
    const [currentnumberofRecords, setCurrentnumberofRecords] = useState(0);
    const [filtersVersion, setFiltersVersion] = useState(0); // Track filter updates


    const getFieldValue = (field, defaultValue = '') => {
        if (!field || !field.Valid) return defaultValue;
        return field.String !== undefined ? field.String :
            field.Bool !== undefined ? field.Bool :
                defaultValue;
    };



    const handleApprovalClick = (certificate) => {
        setSelectedCertificate(certificate);
        setIsOpenAddCertification(true);

        const passReattemptStatus = getFieldValue(certificate.pass_reattempt_status);
        const isCourseCompletion = getFieldValue(certificate.is_course_completion, false);
        const certificationCompletionApproval = getFieldValue(certificate.certification_completion_approval);

        if (passReattemptStatus && passReattemptStatus.toLowerCase() === 'reattempt') {
            setPopupType('reattempt');
        } else if (isCourseCompletion && !certificationCompletionApproval) {
            setPopupType('final');
        } else {
            setPopupType('initial');
        }
    };



    const getSortIcon = (column) => {
        if (sortColumn !== column) {
            return "/Images/sort-icon.svg"; // Default unsorted icon
        }
        return sortOrder === 1 ? "/Images/Sort-up.svg" : "/Images/sort-icon.svg"; // Up or down based on order
    };

    //2.31-2.40 : Handles the status for display
    const getStatusDisplay = (certificate) => {
        // Safely get field values
        const getFieldValue = (field, defaultValue = '') => {
            if (!field || !field.Valid) return defaultValue;
            return field.String !== undefined ? field.String :
                field.Bool !== undefined ? field.Bool :
                    defaultValue;
        };

        // Get all relevant values
        const initialApproval = getFieldValue(certificate.initial_ph_approval, "pending").toLowerCase();
        const isPaymentCompleted = getFieldValue(certificate.is_payment_completed, false);
        const financialApproval = getFieldValue(certificate.financial_approval, "").toLowerCase();
        const certificationCompletion = getFieldValue(certificate.certification_completion_approval, "pending").toLowerCase();
        const isCourseCompleted = getFieldValue(certificate.is_course_completion, false);
        const passReattemptStatus = getFieldValue(certificate.pass_reattempt_status, "").toLowerCase();

        // Determine statuses for each step
        let initialStatus = "pending";
        let paymentStatus = "pending";
        let completionStatus = "pending";
        let statusText = "Pending";
        let statusClass = "pending";

        // Initial Approval Status
        if (initialApproval === "rejected") {
            initialStatus = "rejected";
            statusText = "Rejected";
            statusClass = "rejected";
        }
        else if (initialApproval === "approved") {
            initialStatus = "approved";

            // Payment Status
            if (isPaymentCompleted) {
                paymentStatus = "approved";

                if (certificationCompletion === "approved" && passReattemptStatus === "failed") {
                    statusText = "Certification Failed"; // Set status text for failed certification
                    completionStatus = "rejected"; // Set class to rejected
                }
                else {
                    if (certificationCompletion === "approved") {
                        completionStatus = "approved";
                        statusText = "Course Completed";
                        statusClass = "approved";
                    }
                    else if (certificationCompletion === "inprogress") {
                        completionStatus = "inprogress";
                        statusText = "Certification In Progress";
                        statusClass = "inprogress";
                    }
                    else if (certificationCompletion === "rejected") {
                        completionStatus = "rejected";
                        statusText = "Certification Rejected";
                        statusClass = "rejected";
                    }
                    else {
                        statusText = "Payment Completed";
                        statusClass = "approved";
                    }
                }
            }
            else if (financialApproval === "inprogress") {
                paymentStatus = "inprogress";
                statusText = "Payment In Progress";
                statusClass = "inprogress";
            }
            else {
                statusText = "Approved";
                statusClass = "approved";
            }
        }
        else if (initialApproval === "inprogress") {
            initialStatus = "inprogress";
            statusText = "Initial Approval In Progress";
            statusClass = "inprogress";
        }

        return {
            statusText,
            statusClass,
            initialStatus,
            paymentStatus,
            completionStatus
        };
    };
    // const handleSortChange = (column) => {
    //     const newSortOrder = sortColumn === column ? (sortOrder === 1 ? -1 : 1) : -1;
    //     setSortColumn(column);
    //     setSortOrder(newSortOrder);
    // };


    // SQ_2.17 - 2.30 : handles the approval status
    const postApprovalStatus = async (payload, callback) => {
        setIsLoading(true);
        try {
            const response = await postapprovaldetails(payload);
            if (response.code === 200) {
                const fetchResponse = await fetchCertifications();
                if (fetchResponse.status === "success") {
                    // Update the entire certificates list
                    setCertificates(fetchResponse.data.certificates);
                    // If you have a "selected certificate" or similar, reset it if needed
                    setSelectedCertificate(null); // or set to a specific certificate if needed
                }
                if (callback) callback();
            } else {
                throw new Error(response.message || "Failed to update approval status");
            }
        } catch (error) {
            console.error("Error updating approval status:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleShowMore = () => {
        onShowMore();
    };
    return (

        <div className="">
            {/* Sample Component Table Starts Here */}
            <table className="table bg-white hive-grid mb-3 table-borderless approval-table">
                <thead className="hive-table-head">
                    <tr>
                        <th></th>
                        <th onClick={() => handleSortChange("req_id")}
                            className={`bold-text font-12 cursor-pointer ${sortColumn === "req_id" ? 'sorted' : ''}`}
                        >Request ID <span className="ps-2">
                                <img
                                    src={DOMPurify.sanitize(getSortIcon("req_id"))}
                                    alt="Sort"
                                    className={`hive-table-sort ${sortColumn === "req_id" ? "active-sort" : ""}`}
                                />
                            </span> </th>
                        <th onClick={() => handleSortChange("userid")}
                            className={`bold-text font-12 cursor-pointer ${sortColumn === "userid" ? 'sorted' : ''}`}>Employee ID
                            <span className="ps-2">
                                <img
                                    src={DOMPurify.sanitize(getSortIcon("userid"))}
                                    alt="Sort"
                                    className={`hive-table-sort ${sortColumn === "userid" ? "active-sort" : ""}`}
                                />
                            </span></th>
                        <th onClick={() => handleSortChange("emp_name")}
                            className={`bold-text font-12 cursor-pointer ${sortColumn === "emp_name" ? 'sorted' : ''}`}>Employee Name
                            <span className="ps-2">
                                <img
                                    src={DOMPurify.sanitize(getSortIcon("emp_name"))}
                                    alt="Sort"
                                    className={`hive-table-sort ${sortColumn === "emp_name" ? "active-sort" : ""}`}
                                />
                            </span>
                        </th>
                        <th onClick={() => handleSortChange("cost")}
                            className={`bold-text font-12 cursor-pointer ${sortColumn === "cost" ? 'sorted' : ''}`}>Certification Cost
                            <span className="ps-2">
                                <img
                                    src={DOMPurify.sanitize(getSortIcon("cost"))}
                                    alt="Sort"
                                    className={`hive-table-sort ${sortColumn === "cost" ? "active-sort" : ""}`}
                                />
                            </span>
                        </th>
                        <th onClick={() => handleSortChange("cost_limit")}
                            className={`bold-text font-12 ${sortColumn === "certificate_name" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                }`}>Available Limit  <span className="ps-2">
                                <img
                                    src={DOMPurify.sanitize(getSortIcon("cost_limit"))}
                                    alt="Sort"
                                    className={`hive-table-sort ${sortColumn === "cost_limit" ? "active-sort" : ""}`}
                                />
                            </span></th>
                        <th className='bold-text font-12'>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {certificates?.map(cert => {
                        const { statusText, initialStatus, paymentStatus, completionStatus, statusClass } = getStatusDisplay(cert);
                        const initialApprovalValue = getFieldValue(cert.initial_ph_approval);
                        const isCourseCompletion = getFieldValue(cert.is_course_completion, false);
                        const certificationCompletionApproval = getFieldValue(cert.certification_completion_approval);
                        const hasNewIndicator = initialApprovalValue.toLowerCase() === "pending" ||
                            (isCourseCompletion === true && !certificationCompletionApproval);
                        return (

                            <tr
                                key={cert.req_id}
                                className={`hive-table-data regular-text ${hasNewIndicator ? 'new-line-item' : ''}`}
                            >
                                <td>
                                    {initialApprovalValue.toLowerCase() === "pending" || (isCourseCompletion === true && !certificationCompletionApproval) ? (
                                        <span className="new-item-indicator rounded-circle"></span>
                                    ) : null}
                                </td>
                                <td>
                                    <span
                                        className="text-primary cursor-pointer hover-underline"
                                        onClick={() => handleApprovalClick(cert)}
                                        style={{
                                            color: initialApprovalValue.toLowerCase() === "pending" ? '#0d6efd' : '#6c757d',
                                            textDecoration: initialApprovalValue.toLowerCase() === "pending" ? 'underline' : 'none',
                                            cursor: initialApprovalValue.toLowerCase() === "pending" ? 'pointer' : 'default'
                                        }}
                                    >
                                        {cert.req_id}
                                    </span>
                                </td>
                                <td>{cert.user_id}</td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <img src={DOMPurify.sanitize(getFieldValue(cert.profile_img_url))} alt="profile-img" className="table-image" />
                                        <div className="ms-2">
                                            <p className="text-dark mb-0">{cert.emp_name}</p>
                                            <p className="grey-text mb-0 font-11">{cert.role}</p>
                                            {getFieldValue(cert.client_dependency)}
                                        </div>
                                    </div>
                                </td>
                                <td>{cert.certification_cost}</td>
                                <td>{cert.cost_limit}</td>
                                <td>
                                    <div className="progress-indication-bar d-flex flex-column justify-content-center align-items-start">
                                        <span className={`font-11 mb-1 ${statusClass}`}>
                                            {statusText}
                                        </span>
                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                            <span className={`progress-step ${initialStatus}`}></span>
                                            <span className="progress-line"></span>
                                            <span className={`progress-step ${paymentStatus}`}></span>
                                            <span className="progress-line"></span>
                                            <span className={`progress-step ${completionStatus}`}></span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <p className='font-12 pagination'>
                Showing<span className='bold-text mx-1'>{numberOfRecords}</span> of
                <span className='bold-text mx-1'>{totalRecords}</span> Records
            </p>

            {certificates?.length >= 10 && (
                <div className='text-center'>
                    <button className='btn show-more-btn' onClick={handleShowMore}>Show More</button>
                </div>
            )}

            {isOpenAddCertification && (
                <>
                    {/* Initial Approval Popup */}
                    {popupType === 'initial' && (
                        <InitialApprovalPopup
                            certificate={selectedCertificate}
                            onClose={() => setIsOpenAddCertification(false)}
                            onSubmit={(payload) => postApprovalStatus(payload)}
                            isLoading={isLoading}
                        />
                    )}

                    {/* Final Approval Popup */}
                    {popupType === 'final' && (
                        <FinalApprovalPopup
                            certificate={selectedCertificate}
                            onClose={() => setIsOpenAddCertification(false)}
                            onSubmit={postApprovalStatus}
                            isLoading={isLoading}
                        />
                    )}

                    {/* Reattempt Popup */}
                    {popupType === 'reattempt' && (
                        <ReattemptPopup
                            certificate={selectedCertificate}
                            onClose={() => setIsOpenAddCertification(false)}
                            setIsOpenAddCertification={setIsOpenAddCertification}
                            onSubmit={postApprovalStatus}
                            isLoading={isLoading}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default CertificationList;